import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class WindowPropertiesService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(Window) private window: Window
  ) {
    /**/
  }

  public innerWidth(): number {
    return this.window.innerWidth || this.document.documentElement.clientWidth || this.document.body.clientWidth;
  }

  public innerHeight(): number {
    return this.window.innerHeight || this.document.documentElement.clientHeight || this.document.body.clientHeight;
  }
}